module.exports = __webpack_public_path__ + "static/9-2b1d2e3b8a2e3806a17c4d640ab19e1f.jpg";